import React from 'react';

const UpgradeIcon = ({
  width = 24,
  height = 24,
  className,
  style,
  fill = "currentColor"
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      version="1.1"
      id="XMLID_122_"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      enableBackground="new 0 0 24 24"
      xmlSpace="preserve"
      className={className}
      style={style}
      fill={fill}
    >
      <g id="upgrade">
        <g>
          <path d="M12,24C5.4,24,0,18.6,0,12S5.4,0,12,0s12,5.4,12,12S18.6,24,12,24z M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10    S17.5,2,12,2z M13,18h-2V9.4l-3.3,3.3l-1.4-1.4L12,5.6l5.7,5.7l-1.4,1.4L13,9.4V18z" />
        </g>
      </g>
    </svg>
  );
};

export default UpgradeIcon;
